var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BaseModalComponent } from "./base_modal.component";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
var ConfirmComponent = /** @class */ (function (_super) {
    __extends(ConfirmComponent, _super);
    function ConfirmComponent(activeModal) {
        var _this = _super.call(this, activeModal) || this;
        _this.activeModal = activeModal;
        _this.message = '';
        return _this;
    }
    ConfirmComponent.prototype.ok = function () {
        this.activeModal.close(true);
    };
    return ConfirmComponent;
}(BaseModalComponent));
export { ConfirmComponent };
